import React, { memo } from 'react'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'
import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'

import styles from './ClinicalEvaluationCard.module.sass'

const ClinicalEvaluationCard = memo(
	(props) => {
		const { className, data, ...attributes } = props
		const labels = data.$cardLabels || {}

		return (
			<div
				{...attributes}
				className={`card ${styles['root'] || ''} ${className || ''} ${
					styles[`${data?.$layout}-layout`] || ''
				}`}
			>
				<span className={styles['status-circle']} />
				<div className={styles['header-content']}>
					<span>
						<h5>
							<Icon
								className={styles['text-icon']}
								name='calendar'
								width='14px'
								height='14px'
							/>
							{data.date?.dateTimeFormat}
						</h5>
						<small>
							{`${labels.causalLink}: ${
								data.causalLink === null
									? labels.dubious
									: data.causalLink
									? labels.yes
									: labels.no
							}`}
						</small>
					</span>
					<span className={`${styles['status-container']}`}>
						<span>
							<h5>{data?.doctor?.name}</h5>
							<small>{labels.clinicalEvaluation}</small>
						</span>
						<span className={styles['avatar-container']}>
							<Avatar
								rounded
								className={styles['avatar']}
								user={data?.doctor}
							/>
						</span>
					</span>
				</div>
				{data.$detailLevel !== 'summary' && data.body && (
					<div className={styles['content']}>
						<h5>{labels.clinicalEvaluation}</h5>
						<div dynamic='true' className={styles['comment-body']}>
							<div
								style={{
									minHeight:
										!isNaN(data.textHeight) &&
										data.textHeight > 0
											? data.textHeight
											: undefined,
									maxHeight:
										!isNaN(data.textHeight) &&
										data.textHeight > 0
											? data.textHeight
											: undefined,
								}}
							>
								<ReactMarkdown
									plugins={[breaks]}
									allowedTypes={[
										'break',
										'paragraph',
										'strong',
										'text',
										'list',
										'listItem',
										'code',
									]}
									unwrapDisallowed={true}
								>
									{data.body}
								</ReactMarkdown>
							</div>
						</div>
					</div>
				)}
			</div>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.data.textHeight === nextProps.data.textHeight &&
		prevProps.data.$layout === nextProps.data.$layout &&
		prevProps.data.$detailLevel === nextProps.data.$detailLevel &&
		prevProps.style.top === nextProps.style.top
)
ClinicalEvaluationCard.displayName = 'ClinicalEvaluationCard'
ClinicalEvaluationCard.defaultHeight = 50
ClinicalEvaluationCard.contentDefaultHeight = 1.5

export default ClinicalEvaluationCard

export const ClinicalEvaluationCardSkeleton = (props) => {
	const { className, data, ...attributes } = props
	return (
		<div
			{...attributes}
			className={`${styles['root']} ${styles['row-skeleton']} ${
				className || ''
			} ${styles[`${data?.$layout}-layout`] || ''}`}
		>
			<span className={styles['status-circle']} />
			<div className={styles['header-content']}>
				<span>
					<h5>
						<Skeleton
							className={`${styles['skeleton']} ${styles['small']}`}
						/>
					</h5>
					<small>
						<Skeleton
							className={`${styles['skeleton']} ${styles['smaller']}`}
						/>
					</small>
				</span>
				<span className={`${styles['status-container']}`}>
					<span>
						<h5>
							<Skeleton
								className={`${styles['skeleton']} ${styles['large']}`}
							/>
						</h5>
						<small>
							<Skeleton
								className={`${styles['skeleton']} ${styles['small']}`}
							/>
						</small>
					</span>
					<span className={styles['avatar-container']}>
						<Skeleton
							className={`${styles['skeleton']} ${styles['circle']}`}
						/>
					</span>
				</span>
			</div>
			<div className={styles['content']}>
				<h5>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</h5>
				<small className={styles['comment-body']}>
					<Skeleton
						className={`${styles['skeleton']} ${styles['large']}`}
					/>
				</small>
			</div>
		</div>
	)
}

ClinicalEvaluationCardSkeleton.defaultHeight = 100
ClinicalEvaluationCardSkeleton.verticalDefaultHeight = 192
